import type { CSSProperties } from 'react';

export const bookEventTermsCheckboxStyles: Record<string, CSSProperties> = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  box: {
    position: 'relative',
    width: 18,
    height: 18,
    flexShrink: 0,
    display: 'inline-flex',
  },
  // Matches the ~0.38 fade md-checkbox applied via `ng-disabled` on the
  // pre-migration Angular markup. Scoped to the box (input + check tick)
  // so the label text stays legible.
  boxDisabled: {
    opacity: 0.38,
  },
  input: {
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    width: 18,
    height: 18,
    margin: 0,
    borderRadius: 4,
    border: '1px solid currentColor',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  inputDisabled: {
    cursor: 'not-allowed',
  },
  check: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 18,
    height: 18,
    pointerEvents: 'none',
  },
  text: {
    margin: 0,
    lineHeight: '20px',
  },
  label: {
    margin: 0,
    cursor: 'pointer',
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};
